import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, ArrowRight, Phone, Mail } from "lucide-react";
import { motion } from "framer-motion";
import { Seo } from "@/components/layout/Seo";
import { SITE } from "@/config/site";

export default function Merci() {
  const { state } = useLocation();
  const isDevis = state?.type !== "contact";
  return (
    <>
      <Seo title="Merci — votre demande a bien été envoyée | O'RIZON 360" description="Confirmation d'envoi de votre demande à O'RIZON 360." noindex />
      <section className="section bg-concrete min-h-[70vh] flex items-center" data-testid="merci-page">
        <div className="container-x">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="card max-w-2xl p-10 sm:p-14 relative overflow-hidden">
            <span className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-copper-soft" aria-hidden="true" />
            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 200, damping: 14, delay: 0.2 }}>
              <CheckCircle2 size={56} className="text-copper" />
            </motion.div>
            <p className="eyebrow mt-8 mb-4">Demande envoyée</p>
            <h1 className="h-display text-4xl sm:text-5xl" data-testid="merci-title">Merci{state?.name ? `, ${state.name.split(" ")[0]}` : ""} !</h1>
            <p className="mt-5 text-ink/85 leading-relaxed text-lg">
              {isDevis ? "Votre demande de devis a bien été envoyée." : "Votre message a bien été envoyé."} Nous vous répondons sous <strong>48 heures ouvrées</strong>. Un accusé de réception vous a été adressé par email.
            </p>
            <p className="mt-3 text-sm text-muted">Pas d'email reçu ? Vérifiez votre dossier « indésirables » ou contactez-nous directement.</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link to="/" className="btn-primary" data-testid="merci-home-button">Retour à l'accueil <ArrowRight size={18} /></Link>
              <Link to="/realisations" className="btn-outline" data-testid="merci-realisations-button">Voir nos réalisations</Link>
            </div>
            <div className="mt-8 pt-6 border-t border-line flex flex-col sm:flex-row gap-4 text-sm">
              <a href={SITE.phone.href} className="inline-flex items-center gap-2 font-semibold text-slate hover:text-copper"><Phone size={16} className="text-copper" /> {SITE.phone.display}</a>
              <a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-2 font-semibold text-slate hover:text-copper"><Mail size={16} className="text-copper" /> {SITE.email}</a>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
}
